import { NgModule } from 'ng-metadata/core';
import { PasswordStrengthComponent } from './password-strength/password-strength.component';
import { FormHeaderComponent } from './form-header/form-header.component';
import { PasswordStrengthService } from './password-strength/password-strength.service';
import './_form.scss';

/**
 * @ngdoc module
 * @name mw.components.form
 * @description
 *
 * Menu
 */
@NgModule({
    imports: ['ngMaterial'],
    declarations: [ PasswordStrengthComponent, FormHeaderComponent ],
    providers: [{ provide: 'mwPasswordStrengthService', useClass: PasswordStrengthService}]
})
export class FormModule {}



// WEBPACK FOOTER //
// ./src/lib/components/form/form.module.ts